export default {
    title: '夕尔',
    logo: require('@/../extends/logo.png')
};
